<template>
  <div class="container">

    <heading-one class="-margin-md">口座のご登録</heading-one>

    <wizard-group class="-margin-md">
      <main-wizard :active-index="2" type="entry"></main-wizard>
    </wizard-group>

    <section>
      <notice-box class="-success -margin-md">
        <notice-header>
          <h2 class="heading">口座のご登録ならびにご本人さま確認が完了しました。<br>「お申し込みを完了する」を押してください。</h2>
        </notice-header>
      </notice-box>

      <btngroup-single class="-margin-lg">
        <btn-main class="-main" routerName="tem006" onmousedown="dlpoloan_kouzatourokuClickCv()">
          お申し込みを完了する
        </btn-main>
      </btngroup-single>

    </section>

  </div>
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import NoticeBox from '../components/box/NoticeBox'
import NoticeHeader from '../components/box/NoticeHeader'
import TableGroup from '../components/tables/TableGroup'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
export default {
  name: 'Tem-002',
  metaInfo: {
    title: '口座のご登録',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,口座登録'}
    ]
  },
  components: {
    BtnMain,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    NoticeHeader,
    NoticeBox,
    MainWizard,
    WizardGroup,
    HeadingOne
  },
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Tem002.vue